// extracted by mini-css-extract-plugin
export default {"back":"Back_back__DXJln","bgBlue":"Back_bgBlue__hAT1p"};